import React, { useEffect } from 'react'
import { Button, Form, InputGroup } from 'react-bootstrap';
import { Controller, useForm } from 'react-hook-form';
import ReactInputMask from 'react-input-mask';
import swal from 'sweetalert';

import './index.css'
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import WYSIWYGEditor from './WYSIWYGEditor';
import htmlParser from 'html-react-parser'

export default function FirmwareForm({ saveFirmware, onClose, firmwares, notes }) {
  const { register, handleSubmit, control, setValue } = useForm();

  useEffect(() => {
    if (notes)
      setValue('version', notes.version)
  }, [notes])// eslint-disable-line react-hooks/exhaustive-deps

  const onSubmitFirmware = async (data) => {
    //compara a última versão
    let currentVersion = data.version.replace(/\D/g, "");
    let result = firmwares.map(({ version }) =>
      parseInt(version.replace(/\D/g, ""))
    )
    let lastVersion = Math.max(...result)

    if (currentVersion <= lastVersion) {
      swal("Erro!", "A nova versão não pode ser menor ou igual a atual", "error")
    } else {
      await saveFirmware(data);
    }
  }

  return (
    <div className='FirmwareForm'>
      <Form inline className="search" onSubmit={handleSubmit(onSubmitFirmware)}>
        <Form.Label>Número da versão:</Form.Label>
        <InputGroup>
          <ReactInputMask
            mask="9.9.9"
            id="inputFirmwareVersion"
            placeholder="Digite a versão"
            type="text"
            name="version"
            inputRef={register}
            required
            disabled={notes && true}
            readOnly={notes && true}
            className="form-input form-control"
          />
        </InputGroup>
        <Form.Label>Descrição da versão:</Form.Label>
        {notes ?
          <div>
            {htmlParser(notes.notes)}
          </div>
          :
          <InputGroup>
            <Controller
              as={<WYSIWYGEditor />}
              name='notes'
              control={control}
            />
          </InputGroup>
        }
        {!notes &&
          <>
            <Form.Label>Arquivo de atualização:</Form.Label>
            <InputGroup>
              <Form.Control
                id="inputFirmwareGlb"
                type="file"
                name="file"
                ref={register}
                required
                className="form-input" />
            </InputGroup>
          </>
        }
        <InputGroup>
          {notes ?
            <Button variant="default" type="button" onClick={() => {
              onClose()
            }}>
              Voltar
          </Button>
            :
            <Button variant="primary" type="submit">
              Adicionar
          </Button>
          }
        </InputGroup>
      </Form>
    </div>
  )
}
